/* eslint-disable max-len */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { dataService } from "../../../services/data.services";
import { CognitoData } from "../../../CommonMethods/CognitoData";


const initialState = {
    loading: true,
    error: '',
    success: '',
}
export const Feeterm = createAsyncThunk('feeterms', async (searchParams) => {
    const user = await CognitoData();
    let branch_id = '';
  
    if (user.idToken.payload['custom:user_type'] === 'institution-user' || user.idToken.payload['custom:user_type'] === 'institution-admin') {
        branch_id = JSON.parse(localStorage.getItem('branch_details')).id;
    } else {
        branch_id = user.idToken.payload['custom:branch_id'];
    }
  
    // Ensure searchParams is a URLSearchParams instance
    const params = new URLSearchParams(searchParams);
  
    // If page_number is not in searchParams, add it with a default value of 1
    if (!params.has('page_number')) {
        params.append('page_number', '1');
    }
  
    const res = await dataService.GetAPI(`feeterms?branch_id=${branch_id}&${params.toString()}`);
    return res;
});
const FeeTermSlice = createSlice({

    name: 'institution-user-list',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = true
        },
        handleDataRoles: (state, action) => {
            state.roleList = action.payload
        }

    },
    extraReducers: {
        [Feeterm.pending]: (state) => {
            state.loading = true
            state.error = null
        },
        [Feeterm.fulfilled]: (state, action) => {
            state.loading = false;
            if(!action?.payload?.error && action?.payload?.data.status===200){
                state.List=action?.payload?.data.data;
                
            }else{
                state.error=action?.payload?.data?.message
            }
        },
        [Feeterm.rejected]: (state, { payload }) => {
            state.loading = false
            state.error = payload?.message?.message
        },
    },
})
export const { setLoading,handleDataRoles } = FeeTermSlice.actions;
export default FeeTermSlice.reducer